/**
 * Auth error messages that indicate an expired or invalid session.
 * Used by Apollo error links to detect when to clear session and redirect to login.
 * Must match the exact error strings returned by the backend.
 */
export const IGNORED_AUTH_ERRORS = [
  "Signature verification failed",
  "Signature has expired",
  "400 Bad Request: The CSRF tokens do not match.",
  "400 Bad Request: The CSRF token is invalid.",
  "400 Bad Request: The CSRF token has expired.",
  "400 Bad Request: The CSRF token is missing.",
  "400 Bad Request: The CSRF session token is missing.",
  'Missing JWT in cookies or headers (Missing cookie "access_token_cookie"; Missing Authorization Header)',
];
